import { Subject } from 'rxjs';

export class RouterPatchComponent {
    static navigateByUrl = new Subject();
}
